export default __webpack_public_path__ + "static/media/VehicleRange.3e8c4f6a.png";